import React from 'react';
import ContactListBase from './ContactListBase';

// Lists the leads, both organizations and private persons
const LeadList: React.FC = () => {
    return (
        <ContactListBase
            listKey='contact_lead'
            objectName='lead.general.object_name'
            defaultParams={{ contact_type_filter: 'lead' }}
            formLinkedItem={{ contact_type: 'lead' }}
            showEntityTypeFilter
        />
    );
};

export default LeadList;
